var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.920455,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.4602H18.4602V16V8V7.53977H18H16H15.5398V8V16V16.4602H16H18ZM14 16.4602H14.4602V16V11C14.4602 8.53982 12.4602 6.53977 10 6.53977C7.53982 6.53977 5.53977 8.53982 5.53977 11V16V16.4602H6H8H8.46023V16V13.4602H11.5398V16V16.4602H12H14ZM15.5398 6V6.46023H16H18H18.4602V6V5C18.4602 4.20382 17.7962 3.53977 17 3.53977C16.2038 3.53977 15.5398 4.20382 15.5398 5V6ZM20 16.4602H21.5398V17.5398H2.46023V16.4602H4H4.46023V16V11C4.46023 7.94118 6.94118 5.46023 10 5.46023C11.4199 5.46023 12.7108 5.99847 13.6926 6.87953L14.4602 7.56835V6.537V5C14.4602 3.60418 15.6042 2.46023 17 2.46023C18.3958 2.46023 19.5398 3.60418 19.5398 5V16V16.4602H20ZM9.46023 10C9.46023 9.70148 9.70188 9.46023 10 9.46023C10.2981 9.46023 10.5398 9.70148 10.5398 10V10.5398H9.46023V10ZM21.5398 20.4602V21.5398H2.46023V20.4602H21.5398Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarm);
export default __webpack_public_path__ + "static/media/farm.542a4154248a2b5932a8d17a3ed13fd7.svg";
export { ForwardRef as ReactComponent };